import { Header } from 'components/Global';
import { PermissionContext } from 'components/Global/AuthLayout';
import SettingsLayout from 'layouts/Settings';
import { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import {
	keyWiseConfigurationRouteMapping,
	keyWisePayrollSettingsRouteMapping,
	keyWiseSettingsRouteMapping,
} from 'utils/mappings';
import { getAllowedModule } from 'utils/utils';

interface SelectedValue {
	key: string;
}

export default function Settings() {
	const configurationKeys = [
		'cost-center',
		'department',
		'job-title',
		'category-code',
		'branch-code',
		'company',
		// 'earning',
		// 'deduction',
		'holidays',
		'leave-type',
		'shift'
	];
	const PayrollSettingsKeys = [
		'company-setup',
		'statutory-components',
		'pay-period',
		'pay-group',
		'payroll-history',
		'mid-month-pay',
		'deduction-code',
		'earning-code',
		'opening-balance'
	];
	const approvalKeys = ['employee', 'time-sheet', 'payroll'];
	const navigate = useNavigate();
	const context = useContext(PermissionContext);
	const pathname = window.location.pathname;
	const pathSegments = pathname.split('/');
	const lastSegment = pathSegments[pathSegments.length - 1];

	const [selectedSidebar, setSelectedSidebar] = useState<string>('');

	// Function to handle sidebar changes
	const sideBarChangeHandler = (selectedValue: SelectedValue) => {
		setSelectedSidebar(selectedValue.key);
		navigate(selectedValue.key);
	};

	useEffect(() => {
		const allowedSettingsModule = getAllowedModule(context.permissions, [
			'Users',
			'Roles',
			'Chart of Accounts',
		]);
		const allowedConfiguration = getAllowedModule(context.permissions, [
			'Company',
			'Branch Code',
			'Category Code',
			'Departments',
			'Cost Center',
			'Job Grade',
			'Leave Type',
			'Holidays',
			'Shift',
		]);
		const allowedPayrollSettings = getAllowedModule(context.permissions, [
			'Company Setup',
			'Statutory Components',
			'Pay Period',
			'Pay Group',
			'Mid-Month Pay Setup',
			'Payroll History',
			'Deduction Code',
			'Earnings Code',
			'Opening Balance'
		]);
		if (lastSegment === 'settings') {
			if (allowedSettingsModule) {
				const _key =
					keyWiseSettingsRouteMapping[
						allowedSettingsModule.toLowerCase() as keyof typeof keyWiseSettingsRouteMapping
					];

				navigate(`/settings/${_key}`);
			} else if (
				context.allowedPermissions.includes('Allow_Configuration')
			) {
				const key =
					keyWiseConfigurationRouteMapping[
						allowedConfiguration?.toLowerCase() as keyof typeof keyWiseConfigurationRouteMapping
					];
				navigate(`/settings/payroll-settings/${key}`);
			} else if (
				context.allowedPermissions.includes('Allow_Payroll_Settings')
			) {
				const key =
					keyWisePayrollSettingsRouteMapping[
						allowedPayrollSettings?.toLowerCase() as keyof typeof keyWisePayrollSettingsRouteMapping
					];
				navigate(`/settings/configurations/${key}`);
			} else {
				navigate(`/`);
			}
		}

		let sidebarKey = lastSegment;
		if (configurationKeys.includes(lastSegment)) {
			sidebarKey = 'payroll-settings';
		} else if (approvalKeys.includes(lastSegment)) {
			sidebarKey = 'approval';
		} else if (PayrollSettingsKeys.includes(lastSegment)) {
			sidebarKey = 'payroll-wizard';
		}
		setSelectedSidebar(sidebarKey);
		
	}, [lastSegment]);

	return (
		<>
			<Header />
			<SettingsLayout
				onSideBarChange={sideBarChangeHandler}
				selectedSidebar={selectedSidebar}
			>
				<Outlet />
			</SettingsLayout>
		</>
	);
}
